import React from 'react';

// Flat-illustration suburban neighborhood band, fetchapro-style.
// Sits at the bottom of the hero. Pure inline SVG for crisp pixel-match.
export const SuburbanBand = ({ className = '' }) => {
  const House = ({ x, body, roof, door, w = 120, h = 90 }) => (
    <g transform={`translate(${x}, ${200 - h})`}>
      {/* roof */}
      <polygon points={`${w / 2},0 ${w},${h * 0.42} 0,${h * 0.42}`} fill={roof} />
      {/* body */}
      <rect x={w * 0.12} y={h * 0.42} width={w * 0.76} height={h * 0.58} fill={body} />
      {/* garage door */}
      <rect x={w * 0.22} y={h * 0.62} width={w * 0.34} height={h * 0.38} fill={door} rx="2" />
      <line x1={w * 0.22} y1={h * 0.74} x2={w * 0.56} y2={h * 0.74} stroke="#ffffff" strokeWidth="1" opacity="0.5" />
      <line x1={w * 0.22} y1={h * 0.86} x2={w * 0.56} y2={h * 0.86} stroke="#ffffff" strokeWidth="1" opacity="0.5" />
      {/* window */}
      <rect x={w * 0.64} y={h * 0.6} width={w * 0.18} height={h * 0.22} fill="#cfe8f5" rx="2" />
    </g>
  );

  const Tree = ({ x, c1 = '#7cb87c', trunk = '#9c6b43', s = 1 }) => (
    <g transform={`translate(${x}, ${200 - 78 * s})`}>
      <rect x={18 * s} y={56 * s} width={8 * s} height={22 * s} fill={trunk} />
      <circle cx={22 * s} cy={40 * s} r={24 * s} fill={c1} />
    </g>
  );

  return (
    <svg
      className={className}
      viewBox="0 0 1440 200"
      preserveAspectRatio="xMidYMax slice"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ overflow: 'hidden', maxWidth: '100%' }}
    >
      {/* ground (grass) */}
      <rect x="0" y="176" width="1440" height="24" fill="#dcefcf" />
      <rect x="0" y="188" width="1440" height="12" fill="#cce6b8" />

      <Tree x={20} c1="#86c08a" s={1.05} />
      <House x={70} body="#fde9c8" roof="#e9a06b" door="#c9863f" />
      <Tree x={205} c1="#76b07c" />
      <House x={250} body="#dceaf2" roof="#8fb7cc" door="#6f95ab" h={100} />
      <House x={400} body="#fbe2e0" roof="#d98a84" door="#b96b65" />
      <Tree x={530} c1="#86c08a" s={1.1} />
      <House x={585} body="#eae3f3" roof="#a896c4" door="#8a78a8" h={96} />
      <House x={735} body="#fde9c8" roof="#e9a06b" door="#c9863f" />
      <Tree x={865} c1="#76b07c" />
      <House x={910} body="#dceaf2" roof="#8fb7cc" door="#6f95ab" h={104} />
      <House x={1065} body="#fbe2e0" roof="#d98a84" door="#b96b65" />
      <Tree x={1195} c1="#86c08a" s={1.05} />
      <House x={1245} body="#eae3f3" roof="#a896c4" door="#8a78a8" h={96} />
      <Tree x={1390} c1="#76b07c" s={1.1} />
    </svg>
  );
};
